import { useQuery } from "@tanstack/react-query";

import { getPartnersPartnerIDDocuments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "./queryKeys";

export function usePartnerDocumentsQuery(partnerID: string | undefined) {
  return useQuery({
    queryKey: PARTNERS_QUERY_KEYS.documents(partnerID!),
    queryFn: processResponse(() => getPartnersPartnerIDDocuments(partnerID!)),
    enabled: !!partnerID,
  });
}
